import "@babel/polyfill";
import "mutationobserver-shim";
import "./component-hooks";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import Vuetify from "vuetify";
import { vuetifyOptions } from "./plugins/vuetify";
import "./plugins/vee-validate";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "vuetify/dist/vuetify.min.css";
import vuePersianFilters from "vue-persian-filters";

import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
Vue.use(VuePersianDatetimePicker, {
  name: 'custom-date-picker',
  props: {
    inputFormat: 'YYYY-MM-DD HH:mm',
    format: 'jYYYY-jMM-jDD HH:mm',
    editable: false,
    inputClass: 'form-control my-custom-class-name',
    placeholder: 'انتخاب تاریخ',
    altFormat: 'YYYY-MM-DD',
    color: '#00acc1',
    autoSubmit: false,
    //...
    //... And whatever you want to set as default
    //...
  }
});

Vue.use(vuePersianFilters);
import { BootstrapVue, IconsPlugin, LayoutPlugin } from "bootstrap-vue";
import OtpInput from "@bachdgvn/vue-otp-input";

Vue.use(IconsPlugin);
Vue.use(LayoutPlugin);
Vue.use(BootstrapVue);

Vue.component("v-otp-input", OtpInput);

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import "@mdi/font/css/materialdesignicons.css";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
  vuetify: new Vuetify(vuetifyOptions),
}).$mount("#app");
